import { DISPLAY_TYPES } from '../../constants/adjustments-and-reclasses/displayTypes.constant';
import { CellId } from '../../enums/adjustments-and-reclasses/CellId.enum';

export type NumericCell = { value: number | null | undefined; type: typeof DISPLAY_TYPES.numeric; id: CellId };
